var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01 align center"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.00004 13.6666C5.6815 13.6666 4.39257 13.2756 3.29624 12.543C2.19991 11.8105 1.34543 10.7693 0.840847 9.55114C0.336263 8.33297 0.20424 6.99253 0.461475 5.69932C0.71871 4.40611 1.35365 3.21823 2.286 2.28588C3.21835 1.35353 4.40623 0.718588 5.69944 0.461353C6.99265 0.204118 8.33309 0.336141 9.55126 0.840725C10.7694 1.34531 11.8106 2.19979 12.5432 3.29612C13.2757 4.39245 13.6667 5.68138 13.6667 6.99992C13.6648 8.76744 12.9618 10.462 11.712 11.7119C10.4621 12.9617 8.76757 13.6647 7.00004 13.6666ZM7.00004 1.44437C5.90126 1.44437 4.82715 1.77019 3.91354 2.38065C2.99994 2.9911 2.28787 3.85876 1.86738 4.8739C1.44689 5.88905 1.33687 7.00608 1.55124 8.08376C1.7656 9.16143 2.29471 10.1513 3.07167 10.9283C3.84863 11.7052 4.83854 12.2344 5.91621 12.4487C6.99388 12.6631 8.11092 12.5531 9.12606 12.1326C10.1412 11.7121 11.0089 11 11.6193 10.0864C12.2298 9.17282 12.5556 8.09871 12.5556 6.99992C12.554 5.52699 11.9681 4.11485 10.9266 3.07334C9.88511 2.03182 8.47297 1.44598 7.00004 1.44437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.91183 8.99984L4.33337 8.05742L6.57631 6.62545V3.6665H7.66671V7.24114L4.91183 8.99984Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/in_progress.f06a78e7c1b2efb1908b3c686faf2b79.svg";
export { ForwardRef as ReactComponent };